import React from 'react'

function SpinLoader() {
    return (
        <>
            <div className='loader-spin'></div>
        </>
    )
}

export default SpinLoader
